import React, { useState, useEffect } from 'react';
import {
    Input,
    InputGroup,
    Stack,
    Breadcrumb,
    Divider,
    Panel,
    Container,
    Table,
    Button,
    DatePicker,
    Modal,
    Message,
    useToaster,
    Toggle,
    IconButton,
    Whisper,
    Tooltip,
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import { Icon } from '@rsuite/icons';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import AddOutlineIcon from '@rsuite/icons/AddOutline';
import TrashIcon from '@rsuite/icons/Trash';
import { Link } from 'react-router-dom';
import { differenceInDays } from 'date-fns';
import ugr from '@/UGRoute';

const { Column, HeaderCell, Cell } = Table;
const TradeFairMaster = () => {
    const ip = globalIP;
    const [fairStatuses, setFairStatuses] = useState({});
    const [fairdata, setFairData] = useState([]);
    const [fairmeta, setFairmeta] = useState(0);
    useEffect(() => {
        fetchDataEnc();
    }, []);
    const fetchDataEnc = async () => {
        const response = await fetch(`${ip}/api/fair-masters?populate=*`);
        const json = await response.json();
        const statuses = json.data.reduce((statusObj, fair) => {
            statusObj[fair.id] = fair.attributes.fairstatus;
            return statusObj;
        }, {});
        setFairData(json.data);
        setFairmeta(json.meta.pagination.total);
        setFairStatuses(statuses);
    };
    const generateEncCode = () => {
        const nextCode = fairmeta + 1;
        return `FAR-${nextCode.toString().padStart(3, "0")}`;
    };
    const [days, setDays] = useState('0')
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const handleStartDateChange = (value) => {
        const currentDate = new Date();
        if (value && value < currentDate) {
            value = currentDate;
        }
        setStartDate(value);
        updateDays(value, endDate);
    };

    const handleEndDateChange = (value) => {
        const currentDate = new Date();
        if (value && value < currentDate) {
            value = currentDate;
        }
        setEndDate(value);
        updateDays(startDate, value);

    };
    const updateDays = (start, end) => {
        if (start && end) {
            const daysDifference = differenceInDays(end, start);
            setDays(String(daysDifference));
        }
    };


    const [fairm, setFairm] = useState({
        fairCode: "",
        fairName: "",
        sessionFair: "",
        fairdays: "",
        location: "",
        fairstatus: "",
        fairStartDate: "",
        fairEndDate: "",

    });
    const handleInputChange = (inputName, event) => {
        let value;
        if (event && event.target) {
            // If event is not null and has a target property
            value = event.target.value;
        } else {
            // Handle cases where event is null or doesn't have a target property
            value = event;
        }
        // Handle other inputs outside remarks
        setFairm({ ...fairm, [inputName]: value });

    }
    const toaster = useToaster()
    let nextCategoryCode1 = generateEncCode();
    const fairmaster = `${ip}/api/fair-masters`;
    const submit = async (e) => {
        if (startDate == null) {
            toaster.push(<Message showIcon type='error' >
                Please Select Fair Date.
            </Message>, { placement: 'topCenter' });
        }
        else if (endDate == null) {
            toaster.push(<Message showIcon type='error' >
                Please add Fair Date.
            </Message>, { placement: 'topCenter' });
        } else if (fairm.fairName == '') {
            toaster.push(<Message showIcon type='error' >
                Please add Fair Name.
            </Message>, { placement: 'topCenter' });
        }
        else {
            e.preventDefault();
            nextCategoryCode1 = generateEncCode();
            const nextCategoryCode = nextCategoryCode1;
            const updatePromises = fairdata.map((fair) => {
                // Create a new FormData instance for each fair
                const updateFormData = new FormData();
                // Append fair data with the updated status
                updateFormData.append("data", JSON.stringify({
                    ...fair,
                    fairstatus: 'Inactive',
                }));

                // Make the PUT request for each fair
                return fetch(`${ip}/api/fair-masters/${fair.id}`, {
                    method: 'PUT',
                    body: updateFormData,
                });
            });

            // Wait for all updates to complete before adding the new fair
            await Promise.all(updatePromises);
            const formData = new FormData();
            // Set all existing fairs' statuses to inactive

            formData.append("data", JSON.stringify({
                ...fairm,
                fairCode: nextCategoryCode,
                fairStartDate: startDate ? startDate.toISOString().slice(0, 10) : null,
                fairEndDate: endDate ? endDate.toISOString().slice(0, 10) : null,
                fairdays: String(days),
                fairstatus: 'Active'
            }));
            fetch(fairmaster, {
                method: 'POST',
                body: formData,
            })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);
                    handleOpen();
                    // Refresh page after 2 seconds (2000 milliseconds)
                })
                .catch((error) => {
                    console.error(error)
                });
        }
    };
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        fetchDataEnc();
        setOpen(false);
        setFairm({
            fairCode: "",
            fairName: "",
            sessionFair: "",
            fairdays: "",
            location: "",
            fairstatus: "",
            fairStartDate: "",
            fairEndDate: "",
        });
        setStartDate(null);
        setEndDate(null);
        setDays('0')
    }
    const handleToggleChange = async (rowData, checked) => {
        try {
            const updatedFair = {
                ...rowData.attributes,
                fairstatus: checked ? 'Active' : 'Inactive',
            };

            // If activating a fair, deactivate all other fairs
            if (checked) {
                const deactivatePromises = fairdata
                    .filter((fair) => fair.id !== rowData.id && fair.attributes.fairstatus === 'Active')
                    .map((fair) => {
                        return fetch(`${ip}/api/fair-masters/${fair.id}`, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ data: { ...fair.attributes, fairstatus: 'Inactive' } }),
                        });
                    });

                // Wait for all deactivations to complete before updating the current fair
                await Promise.all(deactivatePromises);
            }

            // Update the current fair's status
            await fetch(`${ip}/api/fair-masters/${rowData.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data: updatedFair }),
            });

            // Update the state based on the new status
            setFairData((prevFairData) => {
                return prevFairData.map((fair) => {
                    if (fair.id === rowData.id) {
                        return { ...fair, attributes: updatedFair };
                    } else {
                        return fair;
                    }
                });
            });
        } catch (error) {
            console.error('Error updating fair status:', error);
        }
        fetchDataEnc();
    };
    const [searchQuery, setSearchQuery] = useState('');
    const handleSearch = (value) => {
        setSearchQuery(value);
    }


    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar" justifyContent="space-between">
                    <Stack direction='column' alignItems='flex-start'>
                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">Fair Master Create</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <Link to={`/${ugr}/dashboard`}>
                                        Home</Link></Breadcrumb.Item>
                                <Breadcrumb.Item active>Create</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                        <Stack spacing={5} alignItems='flex-end'>
                            <Stack direction='column' alignItems='flex-start' >
                                <Stack><p>From Date </p><p style={{ color: 'red' }}>*</p></Stack>
                                <DatePicker
                                    id="startDatePicker"
                                    format="dd/MM/yyyy"
                                    value={startDate}
                                    onChange={(value) => handleStartDateChange(value)}
                                />
                            </Stack>
                            <Stack direction='column' alignItems='flex-start' >
                                <Stack><p>End Date </p><p style={{ color: 'red' }}>*</p></Stack>
                                <DatePicker
                                    id="endDatePicker"
                                    format="dd/MM/yyyy"
                                    value={endDate}
                                    onChange={(value) => handleEndDateChange(value)}
                                />
                            </Stack>

                            <Stack direction='column' alignItems='flex-start' >
                                <Stack><p>Fair Name </p><p style={{ color: 'red' }}>*</p></Stack>
                                <Input style={{ width: 250 }} id='fairName' name="fairName" value={fairm && fairm.fairName ? fairm.fairName : ''} onChange={value => handleInputChange('fairName', value)} />
                            </Stack><Stack direction='column' alignItems='flex-start' >
                                <label>Year Session</label>
                                <Input style={{ width: 100 }} id='sessionFair' name="sessionFair" value={fairm && fairm.sessionFair ? fairm.sessionFair : ''} onChange={value => handleInputChange('sessionFair', value)} />
                            </Stack><Stack direction='column' alignItems='flex-start' >
                                <label>Fair Days</label>
                                <Input style={{ width: 80 }} value={days} readOnly />
                            </Stack><Stack direction='column' alignItems='flex-start' >
                                <label>Location</label>
                                <Input id='location' name="location" value={fairm && fairm.location ? fairm.location : ''} onChange={value => handleInputChange('location', value)} />
                            </Stack>
                            <Button appearance='primary' color='cyan' onClick={submit}>Save</Button>
                        </Stack>
                    </Stack>
                    <Stack direction='column' alignItems='flex-end' spacing={30} style={{ marginBottom: '-27px' }}>
                        <Stack direction='row' spacing={5}>
                            <InputGroup inside >
                                <Input placeholder="Search" value={searchQuery} onChange={(value) => handleSearch(value)} />
                                <InputGroup.Addon>
                                    <SearchIcon />
                                </InputGroup.Addon>
                            </InputGroup>

                        </Stack>

                    </Stack>
                </Stack>
                <Divider className='divide' />
                <div className="row">
                    <Panel>
                        <Table height={420} data={fairdata.filter(item => {
                            const fairName = item.attributes.fairName ? item.attributes.fairName.toLowerCase() : '';
                            const fairCode = item.attributes.fairCode ? item.attributes.fairCode.toLowerCase() : '';
                            const sessionFair = item.attributes.sessionFair ? item.attributes.sessionFair.toLowerCase() : '';
                            const location = item.attributes.location ? item.attributes.location.toLowerCase() : '';
                            return (
                                // Master Search
                                fairName.includes(searchQuery.toLowerCase()) ||
                                fairCode.includes(searchQuery.toLowerCase()) ||
                                sessionFair.includes(searchQuery.toLowerCase()) ||
                                location.includes(searchQuery.toLowerCase())
                                // Master Search
                            );
                        })}
                            rowHeight={60}
                            rowKey="id"
                            bordered
                            cellBordered
                        >
                            <Column width={80} align='center'>
                                <HeaderCell><b>S. NO</b></HeaderCell>
                                <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Fair Code</b></HeaderCell>
                                <Cell dataKey={'attributes.fairCode'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Fair Name</b></HeaderCell>
                                <Cell dataKey={'attributes.fairName'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Session</b></HeaderCell>
                                <Cell dataKey={'attributes.sessionFair'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Fair Days</b></HeaderCell>
                                <Cell dataKey={'attributes.fairdays'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Location</b></HeaderCell>
                                <Cell dataKey={'attributes.location'} />
                            </Column>
                            <Table.Column width={160} align='center'>
                                <HeaderCell><b>Status</b></HeaderCell>
                                <Table.Cell >
                                    {(rowData) => (
                                        <Toggle
                                            checked={fairStatuses[rowData.id] === 'Active'}
                                            onChange={(checked) => handleToggleChange(rowData, checked)}
                                        />
                                    )}
                                </Table.Cell>
                            </Table.Column>
                            <Column width={180} align='center'>
                                <HeaderCell><b>Action</b></HeaderCell>
                                <Table.Cell >
                                    {(rowData) => (
                                        <>
                                            {rowData.attributes.fairstatus === 'Active' && (
                                                <>
                                                    <Stack spacing={10} justifyContent='center'>
                                                        <Whisper followCursor speaker={<Tooltip>Add Products</Tooltip>}>
                                                            <Link to={{ pathname: '/fairCreate', search: `?selectedItems=${rowData.attributes.fairCode}` }}>
                                                                <IconButton icon={<AddOutlineIcon />} active size="sm" />
                                                            </Link>
                                                        </Whisper>
                                                        <Whisper followCursor speaker={<Tooltip>Remove Products</Tooltip>}>
                                                            <Link to={{ pathname: '/fairRemove', search: `?selectedItems=${rowData.attributes.fairCode}` }}>
                                                                <IconButton icon={<TrashIcon />} active size="sm" />
                                                            </Link>
                                                        </Whisper>
                                                    </Stack>
                                                </>
                                            )}
                                        </>
                                    )}
                                </Table.Cell>
                            </Column>

                        </Table>

                    </Panel>
                </div>
                <Modal open={open} onClose={handleClose}>

                    <Modal.Body>
                        <Stack direction='column'>
                            <Icon as={CheckOutlineIcon} color='cyan' style={{ fontSize: '100px', marginBottom: '20px' }} />
                            <b>Saved Successfully</b>
                        </Stack>
                    </Modal.Body>
                    <Modal.Footer>

                        <Button onClick={handleClose} appearance="primary" color='cyan'>
                            Ok
                        </Button>

                    </Modal.Footer>
                </Modal>
                <Stack className="copyright"  justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
                    <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERPDaddy Software Solution.</a></p>
                </Stack>
            </Container>
        </>
    )
}

export default TradeFairMaster;